import React from "react";
import { TextBox } from "@progress/kendo-react-inputs";
import PropTypes from "prop-types";
import { FluentTooltip } from "../../../../../../../components/FluentUI/Fluent-Tooltip";

export const TextboxCell = (props) => {
  const [value, setValue] = React.useState(null);

  React.useEffect(() => {
    setValue(props.dataItem[props.field]);
  }, []);

  const handleChange = (e) => {
    props.onChange({
      dataItem: props.dataItem,
      field: props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });

    setValue(e.target.value);
  };

  return !props.dataItem?.inEdit ? (
    <FluentTooltip
      target={
        <td className="k-table-td">
          {value === null ? "" : value?.toString()}
        </td>
      }
      text={value === null ? "" : value?.text?.toString()}
    ></FluentTooltip>
  ) : (
    <td className="k-table-td">
      <TextBox
        value={value}
        onChange={handleChange}
        title={value === null ? "" : value?.text?.toString()}
      />
    </td>
  );
};
TextboxCell.propTypes = {
  dataItem: PropTypes.object,
  field: PropTypes.string,
  onChange: PropTypes.func,
};
